/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

export function extractWatchlistItems(response) {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.results)) return response.results;
  if (Array.isArray(response?.data?.results)) return response.data.results;
  if (Array.isArray(response?.data)) return response.data;
  return [];
}

function optionSpecificity(item) {
  if (Array.isArray(item?.accounts) && item.accounts.length > 0) return 3;
  if (item?.user) return 2;
  if (item?.is_global) return 1;
  return 0;
}

export function dedupeWatchlistItems(items) {
  const bySymbol = new Map();

  (Array.isArray(items) ? items : []).forEach((item) => {
    const instrument = String(item?.instrument || '').trim();
    if (!instrument) return;

    const exchange = String(item?.exchange || '').trim();
    const key = instrument.toUpperCase();
    const normalized = {
      ...item,
      instrument,
      exchange: exchange || null,
    };
    const existing = bySymbol.get(key);

    if (!existing || optionSpecificity(normalized) > optionSpecificity(existing)) {
      bySymbol.set(key, normalized);
    }
  });

  return Array.from(bySymbol.values()).sort((a, b) => (
    String(a.instrument || '').localeCompare(String(b.instrument || ''), undefined, {
      sensitivity: 'base',
    })
  ));
}

export async function loadWatchlistOptions(listWatchlistItems, params = undefined) {
  const allItems = [];
  let page = 1;
  let hasNext = true;

  while (hasNext && page <= 25) {
    const pageParams = { ...(params || {}) };
    if (page > 1) pageParams.page = page;

    const response = await listWatchlistItems(
      Object.keys(pageParams).length > 0 ? pageParams : undefined,
    );

    allItems.push(...extractWatchlistItems(response));
    hasNext = Boolean(response?.next);
    page += 1;
  }

  return dedupeWatchlistItems(allItems);
}
